import React, { createContext, useContext, useState, ReactNode } from "react";

interface DateContextType {
  // Primary date states
  singleDate: string | null;
  startDate: string | null;
  endDate: string | null;

  // Setters
  setSingleDate: (date: string | null) => void;
  setStartDate: (date: string | null) => void;
  setEndDate: (date: string | null) => void;

  // Derived states
  isSingleDay: boolean;
  isRange: boolean;
}

const DateContext = createContext<DateContextType | undefined>(undefined);

interface DateProviderProps {
  children: ReactNode;
}

export const DateProvider: React.FC<DateProviderProps> = ({ children }) => {
  const [singleDate, setSingleDate] = useState<string | null>(null);
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);

  // Compute derived states
  const isSingleDay = singleDate !== null;
  const isRange = startDate !== null && endDate !== null;

  return (
    <DateContext.Provider
      value={{
        singleDate,
        startDate,
        endDate,
        setSingleDate,
        setStartDate,
        setEndDate,
        isSingleDay,
        isRange,
      }}
    >
      {children}
    </DateContext.Provider>
  );
};

export const useDateContext = (): DateContextType => {
  const context = useContext(DateContext);
  if (context === undefined) {
    throw new Error("useDateContext must be used within a DateProvider");
  }
  return context;
};
